export default __webpack_public_path__ + "static/media/DBI-glyph.b3eed58c.png";